import axios from 'axios';
// /server/libs/authVero.ts
export async function tokenizandoCartao(dados, cnpj) {
    const body = {dados};
    try {
        const url = process.env.VUE_APP_APIURL
        const tokenResponse = await axios.post(`${url}/pagamentos/sitef/tokenizacao`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cnpj,
                body
            },
        });
        return tokenResponse.data.token
    } catch (error) {
        console.error('Erro ao obter o token de autenticação:', error);
        throw new Error('Falha ao obter o token de autenticação da Vero.');
    }
}